import React, { useState } from 'react';
import { Link, useLocation, useHistory } from 'react-router-dom';
import './NavBar.css';
import { LOGGED_IN_KEY } from '../LoginPage';

const navStyle: React.CSSProperties = {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  padding: '12px 40px',
  background: 'var(--main-coffee-bg)',
  borderBottom: '2px solid var(--main-coffee-light)',
  boxShadow: '0 2px 6px rgba(111,78,55,0.12)',
  position: 'relative',
  zIndex: 10
};

const linkBase: React.CSSProperties = {
  textDecoration: 'none',
  fontSize: '1.05rem',
  fontWeight: 600,
  letterSpacing: '0.15em',
  color: 'var(--main-coffee)',
  padding: '8px 14px',
  borderRadius: '8px',
  transition: 'background .18s, color .18s, transform .18s'
};

const activeExtra: React.CSSProperties = {
  background: 'var(--main-coffee)',
  color: '#fff',
  boxShadow: '0 2px 8px rgba(111,78,55,0.25)'
};

interface NavBarProps { theme: 'coffee' | 'blue'; onToggleTheme: () => void }

const NavBar: React.FC<NavBarProps> = ({ theme, onToggleTheme }) => {
  const location = useLocation();
  const history = useHistory();
  const [menuOpen, setMenuOpen] = useState(false);
  const isLoggedIn = Boolean(localStorage.getItem(LOGGED_IN_KEY));
  const handleLogout = () => {
    fetch('/api/logout', { method: 'POST' }).catch(() => {});
    localStorage.removeItem(LOGGED_IN_KEY);
    setMenuOpen(false);
    history.push('/');
  };
  const makeLink = (to: string, label: string, matchExact: boolean = false) => {
    const active = matchExact ? location.pathname === to : location.pathname.startsWith(to);
    return (
      <Link
        key={to}
        to={to}
        style={{ ...linkBase, ...(active ? activeExtra : {}) }}
        onClick={() => setMenuOpen(false)}
        className="navbar-link"
      >
        {label}
      </Link>
    );
  };
  const authLink = isLoggedIn ? (
    <button
      key="logout"
      onClick={handleLogout}
      style={{ ...linkBase, background: 'none', border: 'none', cursor: 'pointer' }}
      className="navbar-link"
    >
      登出
    </button>
  ) : makeLink('/login', '登入');
  return (
    <nav style={navStyle} className="navbar-responsive">
      {/* Hamburger icon for mobile */}
      <button
        className="navbar-hamburger"
        aria-label="Open menu"
        onClick={() => setMenuOpen(m => !m)}
      >
        <span className="navbar-hamburger-icon">
          <span></span>
          <span></span>
          <span></span>
        </span>
      </button>
      <div className="navbar-links">
        {makeLink('/', '主頁', true)}
        {makeLink('/table/video', '視頻')}
        {makeLink('/table/audio', '音頻')}
        {makeLink('/table/text', '文字')}
        {authLink}
      </div>
  {/* Theme switch hidden as requested */}
      {/* Mobile menu overlay */}
      {menuOpen && (
        <div className="navbar-mobile-menu" onClick={() => setMenuOpen(false)}>
          <div className="navbar-mobile-menu-content" onClick={e => e.stopPropagation()}>
            {makeLink('/', '主頁', true)}
            {makeLink('/table/video', '視頻')}
            {makeLink('/table/audio', '音頻')}
            {makeLink('/table/text', '文字')}
            {authLink}
            {/* Theme switch removed in mobile menu */}
          </div>
        </div>
      )}
    </nav>
  );
};

export default NavBar;
